<template>
  <div  class="product imgTOP-current news header-90">
     <div  class="top-img">
       <img src="../assets/images/news-top-img.png" alt="" class="mobile_hide">
       <img src="../assets/images/news-top-imgM.png" alt=""  class="pc_hide">
      <div class="info-box">
        <div class="title-box">
          <h2>Latest News</h2>
          <h3 v-if="$i18n.locale!='en'">{{$t("home_3")}}</h3>
        </div>
      </div>
    </div>
    <div class="product-main">
      <div class="product-conten">
        <div class="product-title navigation">
          <router-link to="/home">{{$t("home_0")}}</router-link>
          <em>/</em>
          <span>{{typeName}}</span>
        </div>
        <div class="newsBoxALL">
          <div class="nav nav-news nav-popup">
            <h4 class="mobile_hide">{{$t("news_4")}}</h4>
            <div class="selecPopup pc_hide" @click="navPopup"><span>{{typeName}}</span> <em></em></div>
            <div class="popup-box pc_hide" v-show="hidePopup">
              <div class="popup-title">
                <span>{{typeName}}</span>
                <a class="close-btn" @click="closePopup"></a>
              </div>
              <ul>
                <li v-for="(item,index) in typeData" :key="index" :class="{active:typeId==item.id}" class="box">
                  <a @click="tabtitle(item.id,item.name)">{{item.name}}</a><em ></em>
                </li>
              </ul>
            </div>
            <ul  class="mobile_hide">
              <li v-for="(item,index) in typeData" :key="index" :class="{active:typeId==item.id}" class="box">
                <a @click="tabtitle(item.id,item.name)">{{item.name}}</a><em class="nav-line"></em>
              </li>
            </ul>
          </div>          
          <div class="news-show">
            <ul>
              <li v-for="(item,index) in newsData" :key="index">
                <router-link :to="'/newsDetails/'+item.id">
                     <div class="img">
                       <img :src="item.image" alt="" v-if="item.image">
                       <iframe :src="item.video" frameborder="0" width="340" height="278" v-if="!item.image"></iframe>
                     </div>
                     <div class="text">
                       <div class="latest-news">
                         <a>{{item.typeName}}</a>
                       </div>
                       <p class="date mobile_hide">{{item.date}}</p>
                       <strong>{{item.title}}</strong>
                       <p class="date pc_hide">{{item.date}}</p>
                       <p class="news-word" v-html="item.content"></p>
                       <div class="more">
                        <a href="#">{{$t("news_8")}}</a>
                         <em></em>
                       </div>
                     </div>
                </router-link>
              </li>
            </ul>
            <my-page :totalPage="totalPage" @changepage="changepage"></my-page>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import API from "./config/api.js";
  import Page from './default/Page.vue';
  export default {
    name: 'News',
    data () {
      return {
        newsData:[],
        typeData:[],
        typeId:0,
        typeName: '',
        typeValue:'',
        pageIndex:0, //當前頁數
        typeData:[],
        typeId:0,
        hidePopup:false,
        pageIndex:1, //请求跳过条数
        pageSize:3, //每页显示条数
        totalPage: 0 //總頁數
      }
    },
    metaInfo() {
      const baseUrl = 'https://www.8way.com.tw';
      let ogTitle = '';
      let ogDescription = '';
      let ogImage = '';
      let schemaData = null;
      let typeId = this.$route.params.id;

      // 根據 typeId 設定 OG tags
      switch(typeId){
        case '0401':
          ogTitle = '八方雲集 - 最新消息 Latest News';
          ogDescription = '查看八方雲集的最新消息與活動資訊,掌握品牌動態、新品上市、店面優惠等第一手消息。';
          ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          break;
        case '0402':
          ogTitle = '八方雲集 - 重要公告 Important Notice';
          ogDescription = '查看八方雲集的重要公告與聲明,包含公司重大訊息、營運公告等內容。';
          ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          break;
        default:
          ogTitle = '八方雲集 - 最新消息';
          ogDescription = '八方雲集的最新消息與重要公告,隨時掌握品牌最新動態。';
          ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
      }

      // 根據 typeId 設定不同的 itemListElement
      let itemListElement = [];
      if (typeId === '0401') {
        itemListElement = [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "八方雲集攜手新北市政府 推動「有愛八方．藝文送暖-全齡藝文閱讀推廣計畫」",
            "url": `${baseUrl}/newsDetails/2037`,
            "image": "https://www.8way.com.tw/8WayApi/document/6606a333-95c9-4f22-b056-9a1de65eceff.jpg",
            "datePublished": "2025-01-10",
            "description": "為了響應新北市政府持續推動的藝文活動，八方雲集國際股份有限公司向新北市政府捐贈新臺幣100萬元，並共......"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "八方雲集推出全新「金牌牛肉冬粉系列」，三款美味同步上市",
            "url": `${baseUrl}/newsDetails/2036`,
            "image": "https://www.8way.com.tw/8WayApi/document/efeade82-7753-4540-bf86-2eb524867003.jpg",
            "datePublished": "2025-01-03",
            "description": "八方雲集於今年首次參加台北市國際牛肉麵大賽並獲得金牌獎項，主廚梁社漢也因此掀起了一波網路熱議。借助這......"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "八方雲集支持台灣農業  契作高麗菜&白米",
            "url": `${baseUrl}/newsDetails/2034`,
            "image": "https://www.8way.com.tw/8WayApi/document/84fa9560-8b57-4dc9-b87a-c2c867eadeef.jpg",
            "datePublished": "2024-04-25",
            "description": "今年八方雲集與「彩田米」農友已簽約契作5萬2千5百公斤的米，收成時捐贈給新北市金山、萬里兩個地區包括......"
          }
        ];
      } else if (typeId === '0402') {
        itemListElement = [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "防範詐騙",
            "url": `${baseUrl}/newsDetails/2035`,
            "image": "https://www.8way.com.tw/8WayApi/document/b89e5660-4375-4136-96c1-df88d5f4de64.jpg",
            "datePublished": "2025-03-10",
            "description": "經民眾反應，近日有不肖人士透過網路社群，散佈八方雲集門市將辦理小小主廚的體驗活動，並預先收取活動費用......"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "八方雲集商品禮券(提貨券) 履約保證聲明",
            "url": `${baseUrl}/newsDetails/13`,
            "image": "https://www.8way.com.tw/8WayApi/document/1db6d64e-2067-4227-9065-06236cdaed95.jpg",
            "datePublished": "2021-03-09",
            "description": "貴消費者取得本公司八方雲集商品禮券(提貨券)所預先支付之款項，\r\n均已事前存入於國泰世華商業銀行開立......"
          }
        ];
      }

      // 根據 typeId 設定 Schema
      switch (typeId) {
        case '0401':
          schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": `${baseUrl}/news/0401#collection`,
            "url": `${baseUrl}/news/0401`,
            "name": "最新消息",
            "description": "八方雲集最新消息列表，包含品牌活動、公益合作與新品上市等資訊。",
            "inLanguage": "zh-TW",
            "isPartOf": {
              "@id": `${baseUrl}/news#collection`
            },
            "mainEntity": {
              "@type": "ItemList",
              "name": "最新消息列表",
              "itemListOrder": "https://schema.org/ItemListOrderDescending",
              "itemListElement": itemListElement
            }
          };
          break;
        case '0402':
          schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": `${baseUrl}/news/0402#collection`,
            "url": `${baseUrl}/news/0402`,
            "name": "重要公告",
            "description": "八方雲集重要公告列表，公告防詐騙資訊及商品禮券履約保證相關聲明，提供消費者最新權益與安全提醒。",
            "inLanguage": "zh-TW",
            "isPartOf": {
              "@id": `${baseUrl}/news#collection`
            },
            "mainEntity": {
              "@type": "ItemList",
              "name": "重要公告列表",
              "itemListOrder": "https://schema.org/ItemListOrderDescending",
              "itemListElement": itemListElement
            }
          };
          break;
        default:
          schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": `${baseUrl}/news#collection`,
            "url": `${baseUrl}/news`,
            "name": "最新消息",
            "description": "八方雲集最新消息與重要公告，隨時掌握品牌最新動態。",
            "inLanguage": "zh-TW",
            "mainEntity": {
              "@type": "ItemList",
              "name": "新聞列表",
              "itemListOrder": "https://schema.org/ItemListOrderDescending",
              "itemListElement": itemListElement
            }
          };
      }

      return {
        title: ogTitle,
        meta: [
          { property: 'og:title', content: ogTitle },
          { property: 'og:description', content: ogDescription },
          { property: 'og:image', content: ogImage },
          { property: 'og:url', content: window.location.href },
          { property: 'og:type', content: 'website' }
        ],
        script: schemaData ? [
          {
            type: 'application/ld+json',
            json: schemaData
          }
        ] : []
      };
    },
    created(){
      this.typeId = this.$route.params.id;
      this.getTypeList();
    },
    methods:{
      getData:function(){
        this.$post(API.GetWebNewMessageList,{
          "typeId":this.typeId,
          "pageIndex":this.pageIndex,
          "pageSize": this.pageSize
        }).then((response) => {
          if(response.code == 200){
            this.newsData = response.data.dataList;
            this.totalPage = Math.ceil(response.data.totalCount/this.pageSize);
          }
        });
      },
      getTypeList:function(){
        this.$fetch(API.GetTypeList).then((response) => {
          if(response.code == 200){
            this.typeData = response.data;
            if(this.typeId){
              this.typeData.forEach(item => {
                if(this.typeId === item.id){
                  this.typeName = item.name;
                }
              })
            }else{
              this.typeId = this.typeData[0].id;
              this.typeName = this.typeData[0].name;
            }
            this.getData();
          }
        });
      },
      tabtitle(value,name){
        this.typeId = value;
        this.typeName = name;
        this.$router.push({ name: 'News', params: { id: value }});
        this.pageIndex = 1;
        this.getData();
        this.hidePopup= false;
      },
      //分頁
      changepage(currentPage){
        this.pageIndex = currentPage ;
        this.getData();
      },
      //手机菜单弹窗
      navPopup(){
        this.hidePopup= true;
        $('body').addClass('no-scroll');
      },
      closePopup(){
        this.hidePopup= false;
        $('body').removeClass('no-scroll');
      }
    },
    watch: {
      $route: {
        handler() {
          this.typeId = this.$route.params.id;
          this.getTypeList();
        },
        deep: true,
      }
    },
    components:{
      'my-page': Page,
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  ul{
    padding-left:0;
  }
  .newsBoxALL{
      margin-top: 44px;
  }
  .product{
    width: 100%;
    height:auto;
 /* .top-img{
     width: 100%;
     height: 354px;
     position: relative;
     background: url("../assets/images/news-top-img.png") no-repeat center;
     background-size: 100% 100%;
     .bg-img{
       position: absolute;
       width: 100%;
     }
     .info-box{
       width: 100%;
       max-width: 1320px;
       padding: 0 20px;
       margin: 0 auto;
       .title-box{
         float: left;
         padding-top: 60px;
         text-align: right;
          margin-left:7%;
         h2{
           color: #FFFFFF;
           font-size: 70px;
           font-style: italic;
           font-weight: 900;
           letter-spacing: 0;
           line-height: 120px;
           margin: 0;
         }
         h3{
           color: #FFFFFF;
           font-size: 36px;
           letter-spacing: 1px;
           line-height: 42px;
           margin: 0;
         }
       }
     }
   }*/
  .product-main{
    width: 100%;
    height: 100%;
    background: #f9f9f9 url("../assets/images/product-contenBg2.png") no-repeat center top;
    background-size: 100% auto;
    overflow: hidden;
    padding-top:9px;
    padding-bottom: 160px;
  }
  .product-conten{
    max-width:1400px;
    margin-left:269px;
 /* .product-title{
    font-size: 14px;
    padding-bottom:44px;
    letter-spacing: 1.5px;
  a{
    text-decoration: underline;
    color: #000;
  }
  em{
    padding: 0 4px;
  }
  span,em{
    color: #9A928D;
  }
  }*/


  }
  .product-show{
    width: 1000px;
    height: auto;
    float: left;
    padding-left:100px;
  ul{
    padding-left: 0;
  li{
    width: calc(100% / 3) ;
    padding-right: 4%;
    float: left;
    margin-bottom: 70px;
  div{
    width: 100%;
    height: 280px;
  img{
    width: 100%;
    height: 100%;
    background-size: 100%;
  }
  }
  p{
    text-align: center;
    padding-top: 20px;
  }
  }
  }
  }
  }


  .news-show{
    width:1045px;
    height:100%;
    float: left;
    padding-left:104px;
    ul{
      padding-left:0;
      li{
       width: 100%;
        height: 278px;
        margin-bottom: 24px;
        background: #fff;
        box-sizing: border-box;
        border-radius: 20px;
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
        position: relative;
        clear: both;
        .img{
          width: 340px;
          height: 100%;
          float: left;
          img{
            width: 100%;
            height: 100%;
            background-size: 100%;
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
          }
          iframe{
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
          }
        }
        .text{
          width: calc(100% - 340px );
          float: left;
          padding: 40px 45px 21px 62px;
          .latest-news{
            height: 26px;
            line-height: 26px;
            width: auto;
            padding: 0 20px;
            background-color: #D00717;
            display: inline-block;
            a{
              color: #fff;
              text-align: center;
              display: block;
              font-size: 14px;
              font-weight: 500;
              letter-spacing: 0.88px;
            }
          }
        .date{
          color: #908782;
          font-size: 14px;
          font-style: italic;
          font-weight: 500;
          padding: 16px 0 6px 0;
          letter-spacing: 0.7px;
        }
        strong{
          font-size: 17px;
          letter-spacing: 1.42px;
          color: #000;
          max-height: 50px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .news-word{
          color: #908782;
          font-size: 16px;
          margin: 6px 0 18px 0;
          max-height: 50px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
       }
      .more{
        position: absolute;
        right: 45px;
        bottom: 23px;
        a{
          color: #D00717;
          font-size: 16px;
          text-align: left;
          letter-spacing: 1px;
        }
        em{
          height:15px;
          width: 130px;
          background: url(../assets/images/nextPageR.svg) no-repeat  ;
          background-size: 100%;
          display: block;
        }
       }
        &:last-child{
          margin-bottom: 11px;
         }
      }
    }
  }
  @media (max-width:1760px){
    .product .product-conten{
      margin-left: 0;
      margin: auto;

    }
    .news-show{
      width: calc(100% - 26%);
      padding-left: 7%;
    }
  }

  @media (max-width:1560px){
    .product .product-conten{
      margin: 0 50px;
    }
  }

  @media (max-width:1080px){
    .product .product-main{
      background: #f9f9f9 url("../assets/images/product-contenBg.png") no-repeat center top;
      background-size:100%;
    }
    .newsBoxALL{
      margin-top: 0;
    }
   /* .product .top-img{
      height: 168px;
      background: url(../assets/images/news-top-imgM.png) no-repeat center top;
      background-size: 100%;
       .info-box{
          max-width: 100%;
          .title-box{
            width: 100%;
            margin-left:0;
            h2{
              font-size: 26px;
                line-height: 1.2;
            }
            h3{
              font-size: 20px;
            }
          }
       }
    }*/
    .news-show{
      width: 100%;
      padding-left: 0;
      padding-bottom: 0;
      ul li{
        height: auto;
        border-top-left-radius:30px;
        border-top-right-radius:30px;
        padding-bottom:40px;
        position:relative;
        .img {
          width: 100%;
          float: none;
            img,iframe{
              width: 100%;
              border-top-left-radius:30px;
              border-top-right-radius:30px;
              border-bottom-left-radius: 0;
            }
        }
        .text{
          width: 100%;
          padding: 0;
          float: none;
          padding: 16px 18px;
         padding-bottom:30px;
          strong{
            font-size: 16px;
            padding-top:14px;
            display: block;
            overflow: auto;
            display: block;
            max-height: none;
          }
         .date{
           padding-top: 4px;
           padding-bottom: 2px;
           font-size: 14px;
         }
         .news-word{
           font-size: 15px;
           letter-spacing: 0.5px;
           line-height: 28px;
           margin-bottom: 0;
           overflow: auto;
           display: block;
           max-height: none;
         }
        }
        .more{
          bottom: 20px;
          right: 17px;
          a{
            font-size: 15px;
            letter-spacing: 0;
          }
          em{
            width: 72px;
          }
        }
      }
    }

  .product .product-conten{
    padding:0;
    margin: 0;
  }

  }
</style>



// WEBPACK FOOTER //
// src/components/news.vue